import PresupuestosGraficoInformesPorEstados from './PresupuestosGraficoInformesPorEstados';

export default PresupuestosGraficoInformesPorEstados;
